// ==============================================
// ==================Import======================
// ==============================================

// ===================Dependancies================
import PropTypes from 'prop-types';

// ==================Style&IMG===================
import './style.scss';

function Date({ value }) {
  return (
    <time className="date--backend" dateTime={value}>{value}</time>
  );
}

Date.propTypes = {
  value: PropTypes.string.isRequired,
};

export default Date;
